import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useUserContext } from "../../providers/userProvider";
import { useNavigate } from "react-router-dom";
import Logo from "../../pictures/Re-evented.webp";
import { useCustomThemeContext } from "../../providers/customThemeProvider";

// RegisterPage component definition
export const RegisterPage: FC = () => {
  const { updateTheme } = useCustomThemeContext();

  // Update theme on component mount
  useEffect(() => {
    updateTheme();
  }, []);

  // State variables for form inputs and error handling
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const { signup } = useUserContext();
  const navigate = useNavigate();

  // Function to handle signup process
  const onSignup = async () => {
    const result = await signup(email, password, username, firstName, lastName);
    if (result.error) {
      setError(result.error);
    } else {
      navigate("/");
    }
  };

  return (
    // Main container for the registration page
    <Box
      display={"flex"}
      flexDirection={"column"}
      width={1}
      minHeight="100vh"
      sx={{
        background: "#e2e2e2",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        flexGrow={1}
        p={2}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          p={5}
          width={1}
          maxWidth={350}
          borderRadius={4}
          sx={{ background: "white" }}
        >
          {/* Logo */}
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "100px", height: "auto", padding: "5px" }}
          />
          <Typography variant="h4" gutterBottom>
            Register
          </Typography>
          {/* Display error message if any */}
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Box component={"form"} autoComplete="off">
            {/* Email input field */}
            <TextField
              required
              type="email"
              variant="outlined"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="normal"
            />
            {/* Password input field */}
            <TextField
              required
              variant="outlined"
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              margin="normal"
            />
            {/* Preferred name input field */}
            <TextField
              required
              variant="outlined"
              label="Preferred name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              required
              variant="outlined"
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              required
              variant="outlined"
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
              margin="normal"
            />
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  required
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                />
              }
              label={
                <>
                  I agree to the{" "}
                  <a href="/terms-and-conditions" rel="noopener noreferrer">
                    terms and conditions
                  </a>{" "}
                  and{" "}
                  <a href="/privacy" rel="noopener noreferrer">
                    privacy policy
                  </a>
                </>
              }
              labelPlacement="end"
            />

            {/* Register button */}
            <Button
              // type="submit" Had to be put into comment to ENABLE FREAKING FIREBASE WORKING FOR SIGN UP
              fullWidth
              disabled={!agreedToTerms}
              variant="contained"
              color="primary"
              onClick={onSignup}
              sx={{ mt: 2 }}
            >
              Register
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default RegisterPage;
